module.exports = __webpack_public_path__ + "img/close-button.46c490a2.svg";